"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getDaysDatesInMonth = exports.getDaysDatesInMonth = function getDaysDatesInMonth(month, year) {
  var date = new Date(year, month, 1);
  var days = [];

  while (date.getMonth() === month) {
    days.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }

  return days;
};

exports.default = getDaysDatesInMonth;